import {documentsService} from "@/_services";
import router from "@/router";
import {signaturesService} from "@/_services/signatures.service";
import {PROVIDER_VERIFICATION} from "../../config/app";

export default {
  searchSigners({}, {query}) {
    return signaturesService.searchSigners(query);
  },
  searchSignersByEmail({}, {email}) {
    return signaturesService.searchSignersByEmail(email);
  },
  getAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getAll(page, sort, company_id, search)
      .then(
        documents => {
          commit("setDocumentsData", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getSignedAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getSignedAll(page, sort, company_id, search)
      .then(
        documents => {
          commit("setDocumentsSignedData", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getRejectAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getRejectAll(page, sort, company_id, search)
      .then(
        documents => {
          commit("setDocumentsRejectedData", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getPartialAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getPendingAll(page, sort, company_id, search)
      .then(
        documents => {
          commit("setDocumentsPendingData", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getInvitedAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getInvitedAll(page, sort, search)
      .then(
        documents => {
          commit("setDocumentsInvitedData", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getInvitedSignedAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getInvitedSignedAll(page, sort, search)
      .then(
        documents => {
          commit("setDocumentsInvitedSigned", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getInvitedPartialAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getInvitedPartialAll(page, sort, search)
      .then(
        documents => {
          commit("setDocumentsInvitedPending", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  getArchivedAll({dispatch, commit}, {page, sort, company_id, search}) {
    documentsService.getArchivedAll(page, sort, company_id, search)
      .then(
        documents => {
          commit("setDocumentsArchived", documents)
          return Promise.resolve(documents);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  createDocument({dispatch, commit}, {document}) {
    dispatch("alert/clear", {}, {root: true});
    return documentsService.createDocument(document)
      .then(
        document => {
          dispatch("alert/success", "El documento se envió a firma", {root:true});
          return Promise.resolve(document);
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  updateDocument({dispatch, commit}, {document, company_id = null}) {
    dispatch("alert/clear", {});
    return documentsService.updateDocument(document, company_id)
      .then(
        document => {
          dispatch("alert/success", "El documento se modificó con éxito", {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  deleteDocument({dispatch, commit}, {document, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return documentsService.deleteDocument(document)
      .then(
        () => {
          dispatch("alert/success", "El documento se eliminó con éxito", {root:true});
          dispatch("account/me", {aclChangeRole}, {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  archiveDocument({dispatch, commit}, {document, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return documentsService.archiveDocument(document)
      .then(
        () => {
          dispatch("alert/success", "El documento se archivo con éxito", {root:true});
          dispatch("account/me", {aclChangeRole}, {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  deArchiveDocument({dispatch, commit}, {document, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return documentsService.archiveDocument(document)
      .then(
        () => {
          dispatch("alert/success", "El documento se ha desarchivado con éxito", {root:true});
          dispatch("account/me", {aclChangeRole}, {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  getDocument({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {});
    return documentsService.getDocument(uuid)
      .then(
        document => {
          return Promise.resolve(document.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          router.push("/");
          return Promise.reject();
        }
      )
  },
  getDocumentFromSignature({dispatch, commit}, {uuid}) {
    dispatch('alert/clear', {}, { root: true });
    return signaturesService.getDocumentInfo(uuid)
      .then(
        document => {
          console.log("Obteniendo información del documento")
          console.log(document.data[0])
          //commit("setDocumentsData", document.data[0])
          return Promise.resolve(document.data[0])
        },
        error => {
          return Promise.reject(error);
        }
      )
  },
  getContainerInformation({dispatch, commit}, {uuid, signatureId}) {
    dispatch("alert/clear", {}, {root: true});
    return signaturesService.getContainerInfo(uuid, signatureId)
      .then(
        container => {
          return Promise.resolve(container.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  sign({dispatch, commit}, {uuid, key, cer, password, pfx}) {
    dispatch("alert/clear", {}, {root:true});
    return signaturesService.sign(key, cer, pfx, password, uuid)
      .then(
        signature => {
          dispatch("alert/success", "El documento se ha firmado correctamente", {root:true})
          return Promise.resolve(signature.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  signSignatureFlow({dispatch, _}, {signatureId, signatureFlowId, svg, video}) {
    dispatch("alert/clear", {});
    return signaturesService.signSignatureFlow(signatureId, signatureFlowId, svg, video)
      .then(
        signature => {
          dispatch("alert/success", "El documento se ha firmado correctamente", {root:true})
          return Promise.resolve(signature.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  signContainer({dispatch, commit}, {uuid, signatureId, key, cer, password, pfx}) {
    dispatch("alert/clear", {}, {root: true});
    return signaturesService.signContainer(key, cer, pfx, password, uuid, signatureId)
      .then(
        () => {
          dispatch("alert/success", "El proceso se ha realizado correctamente", {root:true})
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  reject({dispatch, commit}, {uuid, motive}) {
    dispatch("alert/clear", {});
    return signaturesService.reject(motive, uuid)
      .then(
        signature => {
          dispatch("alert/success", "El documento se ha rechazado correctamente", {root:true})
          return Promise.resolve(signature.data[0])
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  rejectContainer({dispatch, commit}, {uuid, signatureId, motive}) {
    dispatch("alert/clear", {}, {root: true});
    return signaturesService.rejectContainer(motive, uuid, signatureId)
      .then(
        () => {
          dispatch("alert/success", "El contenedor se ha rechazado correctamente", {root:true})
          return Promise.resolve()
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject();
        }
      )
  },
  downloadXml({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {}, { root: true });
    documentsService.downloadXml(uuid)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado el XML", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  downloadPdfOriginal({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {}, { root: true });
    documentsService.downloadPdfOriginal(uuid)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado el PDF", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  downloadPdf({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {}, { root: true });
    documentsService.downloadPdf(uuid)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado el PDF", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  downloadNom151({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {}, { root: true });
    documentsService.downloadNom151(uuid)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado la constancia de conservación", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  downloadAll({dispatch, commit}, {uuid}) {
    dispatch("alert/clear", {}, { root: true });
    documentsService.downloadAll(uuid)
      .then(
        () => {
          dispatch("alert/success", "Se ha descargado el expediente comprimido en ZIP", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  updateSignatureEmail({dispatch, commit}, {email, documentUuid, signatureUuid}) {
    return signaturesService.updateSignatureEmail(email, documentUuid, signatureUuid)
      .then(
        () => {
          return Promise.resolve();
        },
        error => {
          return Promise.reject(error);
        }
      )
  },
  startSignatureFlow(_, {signatureId, providerVerification = PROVIDER_VERIFICATION.VERIFICAMEX}) {
    return signaturesService.startSignatureFlow(signatureId, providerVerification)
      .then(
        result => {
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error)
        }
      )
  },
  retrySignatureFlow(_, {signatureId, signatureFlowId}) {
    return signaturesService.retrySignatureFlow(signatureId, signatureFlowId)
      .then(
        result => {
          return Promise.resolve(result)
        },
        error => {
          return Promise.reject(error)
        }
      )
  },
  resetSignatureFlow(_, {signatureId, signatureFlowId}) {
    return signaturesService.resetSignatureFlow(signatureId, signatureFlowId)
  },
  getSignatureFlow(_, {signatureId, signatureFlowId}) {
    return signaturesService.getSignatureFlow(signatureId, signatureFlowId)
  }
}
